<template>
    <v-textarea :rules="rules" variant="outlined" :placeholder="$t('customer-info.general.input.answer.title')"
        v-model="modelValue" :counter="props.maxLength" :maxlength="props.maxLength">
    </v-textarea>
</template>

<script setup>
import i18n from "@/i18n";
import { defineModel, defineProps } from "vue"
const modelValue = defineModel({
    required: true,
    type: String
})
const props = defineProps({
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    },
    maxLength: {
        type: Number,
        required: false
    }
})
const rules = [
    (v) => {
        return !props.required || !!v || i18n.global.t("customer-info.general.rules.required")
    }
]
</script>

<style lang="scss" scoped></style>